import React from 'react';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import * as Icons from '@mui/icons-material';

// 🔧 Icon rendering helper
function DynamicIcon({ iconName, iconStyle = {} }) {
    const IconComponent = Icons[iconName];
    return IconComponent ? <IconComponent sx={iconStyle} /> : null;
}

// 🧩 Flexible Save Button Component
function Save({ widgetStyle, widgetProps = {} }) {

    const { href, startIcon, startIconName = 'Favorite', endIcon, endIconName = 'Favorite', iconStyle = {}, backgroundHover, colorHover, borderColorHover, data = 'Button' } = widgetProps;
    return (
        <Button
            variant="contained"
            {...(href && !window.location.href.includes('/cms') ? { LinkComponent: Link, to: href } : {})}
            // {...(column.props.href && !window.location.href.includes('/cms') ? { component: Link, to: `${column.props.href}` } : {})}
            startIcon={startIcon ? <DynamicIcon iconName={startIconName} iconStyle={iconStyle} /> : undefined}
            endIcon={endIcon ? <DynamicIcon iconName={endIconName} iconStyle={iconStyle} /> : undefined}
            sx={(theme) => ({
                ...widgetStyle,
                transition: 'all 0.3s ease-in-out',
                ...(backgroundHover && {
                    ':hover': {
                        backgroundColor: backgroundHover || theme.palette.primary.dark
                    }
                }),
                ...(colorHover && { ':hover': { color: colorHover || theme.palette.secondary.main } }),
                ...(borderColorHover && {
                    ':hover': {
                        borderColor: borderColorHover || theme.palette.divider
                    }
                })
            })}

        >
            {data}
        </Button>
    );
}

export default React.memo(Save);
